module.exports = __webpack_public_path__ + "static/media/startup_approved_img.d6914daf.svg";